// src/constants/saleTypes.js

/**
 * Maps URL-friendly sale type strings (as they appear in query params)
 * to their internal single-character IDs used by the API.
 *
 * Used when reading filters from the URL on page load.
 */
export const SALE_TYPE_URL_TO_ID = {
  foreclosure: "F",
  deed: "D",
  "deed sale": "D",
  "tax sale": "A",
  tax: "A",
  certificate: "C",
  "certificate sale": "C",
  blighted: "B",
  "blighted sale": "B",
  "tax lien sale": "O",
  "tax lien": "O",
  "adjudicated sale": "J",
  adjudicated: "J",
  redemption: "R",
  "redemption sale": "R",
};

/**
 * Maps internal single-character sale type IDs to URL-friendly strings.
 *
 * Used when writing the active filter back to the URL.
 */
export const SALE_TYPE_ID_TO_URL = {
  F: "foreclosure",
  D: "deed",
  A: "tax",
  C: "certificate",
  B: "blighted",
  O: "tax lien",
  J: "adjudicated",
  R: "redemption",
};

/**
 * Sale type descriptions as returned by the API.
 * Used to determine display logic (e.g. tax sale vs foreclosure card layout).
 */
export const SALE_TYPE_DESCRIPTIONS = {
  TAX_SALE: "Tax Sale",
  ADJUDICATED_SALE: "Adjudicated Sale",
  TAX_LIEN_SALE: "Tax Lien Sale",
  FORECLOSURE: "Foreclosure",
};

/**
 * Returns true if the sale type description represents a tax-based sale
 * (as opposed to a foreclosure), which affects card and modal layout.
 */
export const isTaxBasedSale = (saleTypeDescription) =>
  [
    SALE_TYPE_DESCRIPTIONS.TAX_SALE,
    SALE_TYPE_DESCRIPTIONS.ADJUDICATED_SALE,
    SALE_TYPE_DESCRIPTIONS.TAX_LIEN_SALE,
  ].includes(saleTypeDescription);